import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="max-w-lg mx-auto px-4 py-24 text-center" data-testid="not-found">
      <div className="font-display text-7xl font-bold tracking-tighter">404</div>
      <p className="text-muted-foreground mt-2 mb-6">This page isn't on the record.</p>
      <Link to="/" className="inline-block h-11 px-6 border-2 border-ink bg-brand text-white font-bold btn-press shadow-brutal-sm leading-[42px]">Go home</Link>
    </div>
  );
}
